// Resmi TC Kimlik No algoritması; hata mesajı ya da null döner.
export const tcError = (raw) => {
  const v = String(raw || "").trim();
  if (!/^\d+$/.test(v)) return "Yalnızca rakam içermeli";
  if (v.length !== 11) return `11 hane olmalı (şu an ${v.length})`;
  if (v[0] === "0") return "İlk hane 0 olamaz";
  const d = v.split("").map(Number);
  const d10 = ((d[0] + d[2] + d[4] + d[6] + d[8]) * 7 - (d[1] + d[3] + d[5] + d[7])) % 10;
  if ((d10 + 10) % 10 !== d[9]) return "10. hane kontrolü tutmuyor";
  if (d.slice(0, 10).reduce((a, b) => a + b, 0) % 10 !== d[10]) return "11. hane kontrolü tutmuyor";
  return null;
};
